<div [ngClass]="{'': context === 'timeline', 'h-100': context === 'addOtherFeedback'}">
    @switch(userRequest.type){
        @case ('MoodRequest'){
            @if(context === 'timeline'){
                <div class="user-request-main row pb-2 m-0">
                    <div class="p-0 pb-2 mb-2 user-request animate__animated animate__fadeIn">
                        <mood-request [requestedMood]="($any(userRequest))"
                                    (onCreate)="onCreateMood($any(userRequest))"></mood-request>
                    </div>
                </div>
            }
        }
        @case('PollRequest'){
            <div class="mb-3">
                <poll-request [context]="context"
                              [pollRequest]="($any(userRequest))"
                              [remainingPollNb]="remainingPollNb"
                              (onQuestionNext)="onRequestNextQuestion()"></poll-request>
            </div>
        }
        @case('KudosRequest'){
            @if(context === 'addOtherFeedback'){
                <kudos-request (onRequestKudos)="onOpenCreateKudosDialog()"></kudos-request>
            }
        }
        @case('FeedbackHookRequest'){
            @if(context === 'timeline'){
                <user-feedback-hook
                        [feedbackHookRequest]="($any(userRequest))"
                        (createQuestion)="requestCreateQuestion()"
                        (createIssue)="requestCreateIssue()"
                        (createKudos)="requestCreateKudos()"
                        (createPoll)="requestCreatePoll()"></user-feedback-hook>
            }
        }
    }
</div>